<template>
  <div>
    <div class="margin-bottom-10 header-group">
      <Select v-model="contract_params.CondList[0].Key" @on-change="change_condList_contract">
        <Option
          v-for="(item,index) in d_search_key_contract"
          :value="item.value"
          :key="index"
        >{{ item.label }}</Option>
      </Select>
      <Input v-model="contract_params.CondList[0].Value" placeholder="请输入搜索内容" />
      <Button type="primary" @click="search_contract()">查询</Button>
    </div>
    <Table
      highlight-row
      ref="currentRowTable"
      height="400"
      border
      :columns="d_columns_contract"
      :data="d_data_contract"
      @on-current-change="get_select_data"
    ></Table>
  </div>
</template>

<script>
import apiContract from "@/api/contract.js";
export default {
  name: "contract",
  data() {
    return {
      d_columns_contract: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "合同编号",
          key: "SerialNum",
        },
        {
          title: "合同名称",
          key: "Name",
        },
      ],
      d_data_contract: [],
      d_search_key_contract: [
        {
          value: "c.ID",
          label: "编号",
        },
        {
          value: "c.Name",
          label: "姓名",
        },
        {
          value: "c.Address",
          label: "地址",
        },
      ],
      contract_params: {},
      d_select_contract: {
        CycleType: "",
        SerialNum: "",
        Name: "",
      },
    };
  },
  methods: {
    change_condList_contract(value) {
      if (value == "c.ID") {
        this.contract_params.CondList[0].Operator = "=";
      } else {
        this.contract_params.CondList[0].Operator = "like";
      }
    },
    search_contract() {
      this.contract_params.PageIndex = 1;
      this.pull_data_contract();
    },
    pull_data_contract() {
      let _this = this;
      if (this.contract_params.CondList[0].Key === "c.Name") {
        sessionStorage.setItem("cName", this.contract_params.CondList[0].Value);
      }
      apiContract.getList.post(this.contract_params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let RowsList = requestResult.RowsList;
          if (RowsList.length > 0) {
            for (let i = 0; i < RowsList.length; i++) {
              if (this.d_select_contract.SerialNum === RowsList[i].SerialNum) {
                RowsList[i]._highlight = true;
              }
            }
            _this.d_data_contract = RowsList;
          } else {
            sessionStorage.getItem("contractInfo");
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    get_select_data(currentRow) {
      //合同选择以后
      this.d_select_contract = {
        ShopIDs: currentRow.ShopIDs,
        CycleType: currentRow.CycleType,
        SerialNum: currentRow.SerialNum,
        Name: currentRow.Name,
      };
      sessionStorage.setItem(
        "contractInfo",
        JSON.stringify(this.d_select_contract)
      );
      this.$emit("selectContract", this.d_select_contract); //传递已经选中的合同
      // this.clear_table_data();
      // this.get_invoice(currentRow.SerialNum);  刷新当前数据
      // this.pull_data();
      // this.pull_data_bill();
    },
  },
  created() {
    this.contract_params = JSON.parse(JSON.stringify(apiContract.getList.data));
    this.contract_params.PageIndex = 1;
    this.contract_params.PageSize = 100;
    this.contract_params.CondList[0].Key = "c.Name";
    this.contract_params.CondList[0].Operator = "like";
    this.contract_params.CondList[0].Value =
      sessionStorage.getItem("cName") || "";
    this.pull_data_contract();
  },

  mounted() {},
};
</script>

<style scoped>
</style>
